export default {
  state: () => ({
    lotteryTickets: []
  }),
  actions: {},
  mutations: {
    LOTTERY_TICKETS(state, payload) {
      state.lotteryTickets = payload
    }
  },
  getters: {
    lotteryTickets: state => state.lotteryTickets
  }
}
